import {GeneratorRequest} from "./GeneratorRequest";

const nomApi = "hourly_rate_prices";

export const HourlyRatePriceRepository = {
    delete : GeneratorRequest.delete(nomApi, true),
    put : GeneratorRequest.put(nomApi, true),
    post : GeneratorRequest.post(nomApi, true),
}
